import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import {
  API_END_POINT,
  STATE_CODES
} from "../constants/const";
import { getAuth, getCompanyId, getCompanyTimeZone, removeAuthOnInvalidToken } from "services/identity.service";
import { getHiringManagerPortalHash } from "services/session.identity.service";

const baseUrl = `${API_END_POINT}`;

const baseQuery = fetchBaseQuery({
  baseUrl: baseUrl,
  prepareHeaders: (headers, { arg }) => {
    if (arg?.headers && typeof arg.headers === "object") {
      Object.entries(arg.headers).forEach(([key, value]) => {
        if (value != null && value !== "") headers.set(key, value);
      });
    }
    const auth = getAuth();
    headers.set("x-access-token", auth?.token || "");
    headers.set("x-company-time-zone", getCompanyTimeZone());
    headers.set("x-company-id", getCompanyId() || null);
    headers.set("x-hiring-manager-portal-hash", getHiringManagerPortalHash() || "");
    return headers;
  },
});

const customFetchBase = async (args, api, extraOptions) => {
  const requestToken = getAuth()?.token;
  let result = await baseQuery(args, api, extraOptions);

  if (result.error?.status === STATE_CODES.UNAUTHORIZED) {
    removeAuthOnInvalidToken(requestToken);
  }
  
  return result;
};

export default customFetchBase;
